module.exports = __webpack_public_path__ + "media/3_31.c6d334ee.wav";